module.exports = __webpack_public_path__ + "img/souvenier-1.7dfa7c88.png";